import React from "react";
import "./MessageToGuests.scss";
import rsvpImage from "./rsvp.png";

const MessageToGuests = ({ weddingData }) => {
  const bride_name = weddingData?.bride_name || "Bride";
  const groom_name = weddingData?.groom_name || "Groom";
  const ceremonyTypeRaw = weddingData?.ceremony_type || "wedding";

  const isHomeComing = (() => {
    const normalized = String(ceremonyTypeRaw).trim().toLowerCase();
    return (
      normalized === "home coming" ||
      normalized === "homecoming" ||
      normalized === "home-coming"
    );
  })();

  const loveNoteImage =
    weddingData?.imageGallery &&
    typeof weddingData.imageGallery === "object" &&
    !Array.isArray(weddingData.imageGallery)
      ? weddingData.imageGallery.loveNoteImage || ""
      : "";

  const displayImage = loveNoteImage || rsvpImage;

  return (
    <section className="message-guests">
      <div className="message-guests__inner">
        <div className="message-guests__image-wrap">
          <img
            src={displayImage}
            alt={`${bride_name} and ${groom_name} wedding`}
            className="message-guests__image"
            loading="lazy"
          />
        </div>

        <div className="message-guests__content">
          <span className="message-guests__eyebrow">A Special Note</span>

          <h2 className="message-guests__title">To Our Lovely Guests</h2>

          <p className="message-guests__text">
            {isHomeComing
              ? "With hearts full of love and gratitude, we are so happy to celebrate this beautiful homecoming with you. Your presence means more to us than words can truly express, and having you by our side makes this day even more meaningful."
              : "With hearts full of love and gratitude, we are so happy to celebrate this beautiful chapter of our lives with you. Your presence means more to us than words can truly express, and having you by our side makes this day even more meaningful."}
          </p>

          <p className="message-guests__text">
            Thank you for your love, your blessings, and for being part of our
            journey. We cannot wait to share laughter, joy, and unforgettable
            memories with the people who mean so much to us.
          </p>

          <p className="message-guests__signature">
            With all our love,
            

              {isHomeComing
            ? <div>
              <span>
              {groom_name} &amp; {bride_name}
            </span>
            </div>
            : <div>
              <span>
              {bride_name} &amp; {groom_name}
            </span>
            </div>}

          </p>
        </div>
      </div>
    </section>
  );
};

export default MessageToGuests;